'use strict';

/* globals jQuery, socket, app, define, config, window, utils */

define('global/window', [], function () {
	return window;
});

define('global/document', ['global/window'], function (window) {
	return window.document;
});


(function ($) {
	function createVideoPlayer(el, data, callback) {
		var videoParams = getVideoParams(el);
		
		if (videoParams.videoId)
			createVideoPlayerFromId(el, data, callback, videoParams);
		else
			createVideoPlayerFromUrl(el, data, callback, videoParams);
	}
	
	function createVideoPlayerFromId(el, data, callback, videoParams) {
		getVideoData(videoParams, function (video) {
			if (!video.isCompressing) {
				addPlayer(el, data, videoParams, video);
			} else {
				addCompressingInfo(el, videoParams, video);
			}

			if (typeof callback !== 'undefined') {
				setTimeout(function () { callback(videoParams.videoId); }, 100);
			}
		});
	}
	
	function createVideoPlayerFromUrl(el, data, callback, videoParams) {
		addPlayer(el, data, videoParams, {
			url: videoParams.videoUrl
		});

		// if (typeof callback !== 'undefined') {
		// 	setTimeout(function () { callback(videoParams.videoId); }, 100);
		// }
	}

	function getVideoDimensionsConfig(page, video, isChatModal) {
		var isVertical = video.height > video.width;

		if (utils.isMobile() && page === 'chats') {
			return { width: '175px' };
		}

		return isVertical || page === 'chats' || isChatModal ?
			{ width: '300px' } :
			{ fluid: true };
	}

	function addPlayer(el, data, videoParams, video) {
		var playerId = 'video-' + videoParams.videoId;

		var ytId = ytVidId(video.url);

		var html = createPlayerHtml(playerId, video.url, videoParams.thumbnailUrl || video.thumbnailUrl);

		var isChatModal = $(el).closest('.chat-modal').length > 0;

		el.replaceWith(html);

		if (videojs.getPlayer(playerId)) {
			videojs(playerId).dispose();
		}

		var options = getVideoDimensionsConfig(data, video, isChatModal);

		if (ytId) {
			options.techOrder = ['html5', 'youtube'];
			options.sources = [{ "type": "video/youtube", "src": "https://www.youtube.com/watch?v=" + ytId }];
		}

		videojs(playerId, options).ready(function () {
			$(window).trigger('videojs:player.ready', { playerId: playerId, videoUrl: video.url, thumbnailUrl: video.thumbnailUrl });
		});
	}

	function addCompressingInfo(el, videoParams, video) {
		require(['translator'], function (translator) {
			var html = createCompressingInfo(videoParams, video.thumbnailUrl);

			translator.translate(html, function (result) {
				el.replaceWith(result);
			});
		});
	}

	function getVideoParams(el) {
		var videoUrl = el.attr('data-video-url');
		var videoId = el.attr('data-video-id');

		var videoIdParam = videoUrl && !videoId ?
			videoUrl.replace('video:', '') :
			el.attr('data-video-id');

		var hasVideoId = isInt(videoIdParam);
		
		return {
			videoId: hasVideoId ? parseInt(videoIdParam, 10) : null,
			videoUrl: !hasVideoId ? videoUrl : null,
			name: el.attr('data-video-name'),
			thumbnailUrl: el.attr('data-video-thumbnail'),
		};
	}

	function isInt(value) {
		return !isNaN(value) &&
			parseInt(Number(value)) == value &&
			!isNaN(parseInt(value, 10));
	}

	function getVideoData(params, callback) {
		socket.emit('plugins.videoSockets.getVideo', params.videoId, function (err, video) {
			if (err) {
				console.error(err.message);

				// needs to wait some time and make another attempt
				setTimeout(function () {
					getVideoData(params, callback)
				}, 5000);
				
				return;
			}

			callback(video);
		});
	}

	function createPlayerHtml(playerId, videoUrl, thumbnailUrl) {
		return '<video id="' + playerId + '" class="video-js" controls preload="auto" poster="' + thumbnailUrl + '">' +
		'<source src="' + videoUrl + '" type="video/mp4"></source>' +
		'<p class="vjs-no-js">To view this video please enable JavaScript, and consider upgrading to a web browser that <a href="https://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a></p>' +
		'</video>';
	}

	function ytVidId(url) {
		var p = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
		
		return (url.match(p)) ? RegExp.$1 : false;
	}

	function createCompressingInfo(videoParams, thumbnailUrl) {
		return '<div data-video-id="' + videoParams.videoId + '" data-video-name="' + videoParams.name + '" class="video-compressing" style="background-image: url(\'' + thumbnailUrl + '\')">' +
		'<p><span>[[video:video-compressing]]</span>' +
		'<span>[[video:video-compressing-wait]]</span>' +
		'<span><i class="fa fa-cog fa-spin fa-2x fa-fw"></i></span></p>' +
		'</div>';
	}

	$.fn.customVideo = function (data, callback) {
		return this.each(function () {
			createVideoPlayer($(this), data, callback);
		});
	};
}(jQuery));
